import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import MobileApp from './mobile/MobileApp';
import AdminApp from "./admin/AdminApp";
import WebApp from "./web/WebApp";

const path = window.location.pathname;

const root = ReactDOM.createRoot(document.getElementById('root'));

if (path.startsWith('/app')) {
    root.render(
        <MobileApp />
    );
} else if (path.startsWith('/admin')) {
    root.render(
        <AdminApp />
    );
} else {
    root.render(
        <WebApp />
    )
}
